import React, {useState,useEffect,useCallback} from "react";
import {
Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography
} from "@mui/material";

import { makeStyles } from "@mui/styles";
import { Formik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import promotionService from "src/services/promotionService";
import mgmtProduct from "src/services/mgmtProduct";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  stepper: {
    marginBottom: theme.spacing(3),
  },
  card: {
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(3),
  },
  nextButton: {
    marginLeft: "auto",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 300,
  },
}));
const steps = [
  "Basic Information",
  "Eligibility",
  "Reward",
  "Usage",
  "Stacking",
];
function PromotionCreateForm({
  className,
  customerId,
  ...rest
}) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const businessInfo = useSelector(
    (state) => state?.app?.businessInfo
  );
  const [activeStep, setActiveStep] = useState(0);
  const [promotionTypes, setPromotionTypes] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState(false);
  const reduxCustomerId =customerId || businessInfo?.customerId;
const customerIdForProducts = reduxCustomerId;
const [products, setProducts] = useState([]);
const [loadingProducts, setLoadingProducts] = useState(false);
const getAllProducts = useCallback(async () => {
  if (!customerIdForProducts) {
    return;
  }
  setLoadingProducts(true);
  try {
    const result = await mgmtProduct.getAllProducts(
      customerIdForProducts
    );
    console.log("ALL PRODUCTS:", result);
    setProducts(result || []);
  } catch (error) {
    console.error("Error fetching products:", error);
    setProducts([]);
  } finally {
    setLoadingProducts(false);
  }
}, [customerIdForProducts]);

useEffect(() => {
  getAllProducts();
}, [getAllProducts]);
  const getPromotionTypes = useCallback(() => {
    setLoadingTypes(true);
    promotionService
      .getPromotionTypes()
      .then((response) => {
        console.log(
          "Promotion Types Response:",
          response?.data
        );
        const responseData = response?.data;
        let types = [];
        if (Array.isArray(responseData)) {
          types = responseData;
        } else if (
          Array.isArray(responseData?.data)
        ) {
          types = responseData.data;
        } else if (
          Array.isArray(responseData?.payload)
        ) {
          types = responseData.payload;
        } else if (
          Array.isArray(responseData?.data?.types)
        ) {
          types = responseData.data.types;
        } else if (
          Array.isArray(responseData?.payload?.types)
        ) {
          types = responseData.payload.types;
        }
        setPromotionTypes(types);
        console.log(
          "Promotion Types:",
          types
        );
      })
      .catch((error) => {
        console.error(
          "Error fetching promotion types:",
          error
        );
        enqueueSnackbar(
          "Failed to load promotion types",
          {
            variant: "error",
          }
        );
        setPromotionTypes([]);
      })
      .finally(() => {
        setLoadingTypes(false);
      });
  }, [enqueueSnackbar]);

  useEffect(() => {
    getPromotionTypes();
  }, [getPromotionTypes]);

  const getPromotionTypeValue = (type) => {
    if (typeof type === "string") {
      return type;
    }
    return (
      type?.value ||
      type?.type ||
      type?.code ||
      type?.name ||
      ""
    );
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string().max(100,"Promotion name must be less than 100 characters").required("Promotion Name is required"),
    type: Yup.string().required("Promotion Type is required"),
    code: Yup.string().max(50,"Code must be less than 50 characters"),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required").test(
        "end-date-after-start-date",
        "End Date must be after or equal to Start Date",
        function (value) {
          const { startDate } = this.parent;
          if (!startDate || !value) {
            return true;
          }
          return value >= startDate;
        }
      ),
    minOrderAmount: Yup.number().min(0,"Minimum Order Value cannot be negative"),
    maxOrderAmount: Yup.number().min(0,"Maximum Order Value cannot be negative"),
    discountValue: Yup.number().min(0,"Discount Value cannot be negative"),
    freeProductId: Yup.string().when("type", {
  is: "FREE_PRODUCT",
  then: (schema) =>
    schema.required("Free Product is required"),
  otherwise: (schema) => schema.notRequired(),
}),
    maxDiscount: Yup.number().min(0,"Maximum Discount cannot be negative"),
    totalUses: Yup.number().min(0,"Total Uses cannot be negative"),
    usesPerUser: Yup.number().min(0,"Uses Per User cannot be negative"),
    usesPerDevice: Yup.number().min(0,"Uses Per Device cannot be negative"),
    usesPerMobile: Yup.number().min(0,"Uses Per Mobile cannot be negative"),});
  const validateCurrentStep = async (
    values,
    validateForm,
    setTouched
  ) => {
    const errors = await validateForm();
    let fields = [];
    if (activeStep === 0) {
      fields = [
        "name",
        "type",
        "startDate",
        "endDate",
      ];
    }
    if (activeStep === 1) {
      fields = [
        "minOrderAmount",
        "maxOrderAmount",
      ];
    }
    if (activeStep === 2) {
  if (values.type === "FREE_PRODUCT") {
    fields = [
      "freeProductId",
    ];
  } else if (values.type) {
    fields = [
      "discountType",
      "discountValue",
    ];
  }
}
    if (activeStep === 3) {
      fields = [
        "totalUses",
        "usesPerUser",
        "usesPerDevice",
        "usesPerMobile",
      ];
    }
    if (activeStep === 4) {
      fields = [
        "stacking",
      ];
    }
    const stepErrors = {};
    fields.forEach((field) => {
      if (errors[field]) {
        stepErrors[field] = errors[field];
      }
    });
    const touchedFields = {};
    fields.forEach((field) => {
      touchedFields[field] = true;
    });
    setTouched(
      touchedFields,
      true
    );
    return (
      Object.keys(stepErrors).length === 0
    );
  };
  const handleNext = async (
    values,
    validateForm,
    setTouched
  ) => {
    const isValid =
      await validateCurrentStep(
        values,
        validateForm,
        setTouched
      );
    if (!isValid) {
      return;
    }
    setActiveStep(
      (prevStep) => prevStep + 1
    );
  };
  const handleBack = () => {
    setActiveStep(
      (prevStep) => prevStep - 1
    );
  };
  const initialValues = {
    name: "",
    customerId:reduxCustomerId || "",
    code: "",
    type: "",
    text: "",
    promotionMethod: "COUPON",
    startDate: "",
    endDate: "",
    active: true,
    minOrderAmount: "",
    maxOrderAmount: "",
    applyTo: "CART",
    excludeSaleItems: false,
    excludeGiftCards: false,
    excludeSelectedProducts: false,
    discountType: "FLAT",
    discountValue: "",
    freeProductId: "",
    minimumOrder: "",
    maxDiscount: "",
    totalUses: "",
    usesPerUser: "",
    usesPerDevice: "",
    usesPerMobile: "",
    stacking: "EXCLUSIVE",
    allowFreeShipping: true,
    allowReferral: true,
  };

  const handleSubmit = async (
    values,
    {
      setErrors,
      setStatus,
      setSubmitting,
      resetForm,
    }
  ) => {
    try {
const promotionData = {
  name: values.name,
  customerId: 109,
  code: values.code,
  type: values.type,
  text: values.text,

  conditions: {
    minOrderAmount: Number(
      values.minOrderAmount || 0
    ),
    minQuantity: 1,
  },

  reward:
    values.type === "FREE_PRODUCT"
      ? {
          freeProductId: values.freeProductId,
        }
      : values.type === "FREE_SHIPPING"
      ? {
          freeShipping: true,
        }
      : values.type === "DISCOUNT" ||
        values.type === "FIRST_ORDER_DISCOUNT"
      ? {
          discountType: values.discountType,
          discountValue: Number(
            values.discountValue || 0
          ),
        }
      : {},
};
      console.log(
        "PROMOTION PAYLOAD:",
        promotionData
      );
      await promotionService.addPromotion(
        promotionData
      );
      setStatus({
        success: true,
      });

      setSubmitting(false);
      enqueueSnackbar(
        "Promotion Created Successfully",
        {
          variant: "success",
        }
      );
      resetForm();
      setActiveStep(0);
    } catch (error) {
      console.error(
        "Failed to create promotion:",
        error
      );
      const errorMessage =
        error?.response?.data?.message ||
        "Failed to create promotion";
      setErrors({
        submit: errorMessage,
      });
      setStatus({
        success: false,
      });
      setSubmitting(false);
      enqueueSnackbar(
        errorMessage,
        {
          variant: "error",
        }
      );
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        setTouched,
        validateForm,
        values,
      }) => (
        <form
          onSubmit={handleSubmit}
          className={className}
          {...rest}
        >
          <Box
            className={classes.root}
          >
            <Stepper
              activeStep={activeStep}
              className={classes.stepper}
              alternativeLabel
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
            {activeStep === 0 && (
              <Card
                className={classes.card}
              >
                <CardContent>
                  <Typography
                    variant="h5"
                    className={
                      classes.sectionTitle
                    }
                  >
                    Basic Information
                  </Typography>
                  <Grid
                    container
                    spacing={2}
                  >
                    {/* Promotion Name */}
                    <Grid
                      item
                      xs={12}
                      md={6}
                    >
                      <TextField
                        fullWidth
                        required
                        label="Promotion Name"
                        name="name"
                        value={values.name}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(
                          touched.name &&
                          errors.name
                        )}
                        helperText={
                          touched.name &&
                          errors.name
                        }
                        variant="outlined"
                      />
                    </Grid>
                    {/* Promotion Type */}
                    <Grid
                      item
                      xs={12}
                      md={6}
                    >
                      <FormControl
                        fullWidth
                        error={Boolean(
                          touched.type &&
                          errors.type
                        )}
                      >
                        <InputLabel>
                          Promotion Type
                        </InputLabel>
                        <Select
                          name="type"
                          value={values.type}
                          label="Promotion Type"
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          {loadingTypes ? (
                            <MenuItem disabled>
                              Loading...
                            </MenuItem>
                          ) : promotionTypes.length > 0 ? (
                            promotionTypes.map(
                              (type, index) => {
                                const typeValue =
                                  getPromotionTypeValue(
                                    type
                                  );
                                return (
                                  <MenuItem
                                    key={
                                      type?.id ||
                                      type?.typeId ||
                                      typeValue ||
                                      index
                                    }
                                    value={typeValue}
                                  >
                                    {type?.name ||
                                      typeValue}
                                  </MenuItem>
                                );
                              }
                            )
                          ) : (
                            [
                              "DISCOUNT",
                              "FREE_PRODUCT",
                              "BOGO",
                              "CASHBACK",
                              "FREE_SHIPPING",
                              "FIRST_ORDER_DISCOUNT",
                            ].map((type) => (
                              <MenuItem
                                key={type}
                                value={type}
                              >
                                {type}
                              </MenuItem>
                            ))
                          )}
                        </Select>
                        {touched.type &&
                          errors.type && (
                            <FormHelperText>
                              {errors.type}
                            </FormHelperText>
                          )}
                      </FormControl>
                    </Grid>
                    {/* Coupon / Automatic */}

                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                      >
                        Promotion Method
                      </Typography>
                      <RadioGroup
                        row
                        name="promotionMethod"
                        value={
                          values.promotionMethod
                        }
                        onChange={(event) => {
                          const method = event.target.value;
                          setFieldValue(
                            "promotionMethod",
                            method
                          );
                          if (method === "AUTOMATIC") {
                            setFieldValue(
                              "code",
                              ""
                            );
                          }
                        }}
                      >
                        <FormControlLabel
                          value="COUPON"
                          control={
                            <Radio />
                          }
                          label="Coupon"
                        />
                        <FormControlLabel
                          value="AUTOMATIC"
                          control={
                            <Radio />
                          }
                          label="Automatic"
                        />
                      </RadioGroup>
                    </Grid>
                    {/* Coupon Code */}
                    {values.promotionMethod ===
                      "COUPON" && (
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Coupon Code"
                          name="code"
                          value={values.code}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                    )}
                    {/* Description */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label="Promotion Description"
                        name="text"
                        value={values.text}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    </Grid>
                    {/* Start Date */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        type="date"
                        label="Start Date"
                        name="startDate"
                        value={
                          values.startDate
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={Boolean(
                          touched.startDate &&
                          errors.startDate
                        )}
                        helperText={
                          touched.startDate &&
                          errors.startDate
                        }
                      />
                    </Grid>
                    {/* End Date */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        type="date"
                        label="End Date"
                        name="endDate"
                        value={
                          values.endDate
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={Boolean(
                          touched.endDate &&
                          errors.endDate
                        )}
                        helperText={
                          touched.endDate &&
                          errors.endDate
                        }
                      />
                    </Grid>
                    {/* Active */}
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="active"
                            checked={
                              values.active
                            }
                            onChange={
                              handleChange
                            }
                          />
                        }
                        label="Active"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}
            {activeStep === 1 && (
              <Card
                className={classes.card}
              >
                <CardContent>
                  <Typography
                    variant="h5"
                    className={
                      classes.sectionTitle
                    }
                  >
                    Eligibility
                  </Typography>
                  <Grid
                    container
                    spacing={2}
                  >
                    {/* Minimum Order */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Minimum Order Value"
                        name="minOrderAmount"
                        value={
                          values.minOrderAmount
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(
                          touched.minOrderAmount &&
                          errors.minOrderAmount
                        )}
                        helperText={
                          touched.minOrderAmount &&
                          errors.minOrderAmount
                        }
                      />
                    </Grid>
                    {/* Maximum Order */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Maximum Order Value"
                        name="maxOrderAmount"
                        value={
                          values.maxOrderAmount
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(
                          touched.maxOrderAmount &&
                          errors.maxOrderAmount
                        )}
                        helperText={
                          touched.maxOrderAmount &&
                          errors.maxOrderAmount
                        }
                      />
                    </Grid>
                    {/* Apply To */}
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                      >
                        Apply to
                      </Typography>
                      <RadioGroup
                        name="applyTo"
                        value={
                          values.applyTo
                        }
                        onChange={
                          handleChange
                        }
                      >
                        <FormControlLabel
                          value="CART"
                          control={
                            <Radio />
                          }
                          label="Entire Cart"
                        />
                        <FormControlLabel
                          value="PRODUCTS"
                          control={
                            <Radio />
                          }
                          label="Products"
                        />
                        <FormControlLabel
                          value="CATEGORIES"
                          control={
                            <Radio />
                          }
                          label="Categories"
                        />
                        <FormControlLabel
                          value="BRANDS"
                          control={
                            <Radio />
                          }
                          label="Brands"
                        />
                      </RadioGroup>
                    </Grid>
                    {/* Exclude */}

                    <Grid
                      item
                      xs={12}
                    >
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                      >
                        Exclude
                      </Typography>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="excludeSaleItems"
                            checked={
                              values.excludeSaleItems
                            }
                            onChange={
                              handleChange
                            }
                          />
                        }
                        label="Sale Items"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="excludeGiftCards"
                            checked={
                              values.excludeGiftCards
                            }
                            onChange={
                              handleChange
                            }
                          />
                        }
                        label="Gift Cards"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="excludeSelectedProducts"
                            checked={
                              values.excludeSelectedProducts
                            }
                            onChange={
                              handleChange
                            }
                          />
                        }
                        label="Selected Products"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}
            {activeStep === 2 && (
              <Card
                className={classes.card}
              >
                <CardContent>
                  <Typography
                    variant="h5"
                    className={
                      classes.sectionTitle
                    }
                  >
                    Reward
                  </Typography>
                  {values.type && (

  <Grid container spacing={2}>
    <Grid item xs={12}>
      <Typography
        variant="subtitle1"
      >
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
      >
      </Typography>
    </Grid>
    {/* FREE PRODUCT */}
    {values.type === "FREE_PRODUCT" && (
      <Grid item xs={12}>
        <Autocomplete
  fullWidth
  options={products}
  loading={loadingProducts}
  value={
    products.find(
      (product) =>
        String(product.productId) ===
        String(values.freeProductId)
    ) || null
  }
  getOptionLabel={(product) =>
    product
      ? `${product.productName} - SKU: ${product.productSKU}`
      : ""
  }
  isOptionEqualToValue={(option, value) =>
    String(option.productId) ===
    String(value.productId)
  }
  onChange={(event, newValue) => {
    setFieldValue(
      "freeProductId",
      newValue
        ? String(newValue.productId)
        : ""
    );
  }}
  onBlur={handleBlur}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Free Product"
      required
      error={
        touched.freeProductId &&
        Boolean(errors.freeProductId)
      }
      helperText={
        touched.freeProductId &&
        errors.freeProductId
      }
    />
  )}
/>
      </Grid>
    )}
    {/* DISCOUNT */}
    {(values.type === "DISCOUNT" ||
  values.type === "FIRST_ORDER_DISCOUNT") && (
      <>
        {/* Discount Type */}
        <Grid
          item
          xs={12}
        >
          <RadioGroup
            row
            name="discountType"
            value={
              values.discountType
            }
            onChange={
              handleChange
            }
          >
            <FormControlLabel
              value="PERCENT"
              control={
                <Radio />
              }
              label="Percentage"
            />
            <FormControlLabel
              value="FLAT"
              control={
                <Radio />
              }
              label="Flat"
            />
          </RadioGroup>
        </Grid>
        {/* Discount Value */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            type="number"
            label="Value"
            name="discountValue"
            value={
              values.discountValue
            }
            onBlur={handleBlur}
            onChange={
              handleChange
            }
            error={Boolean(
              touched.discountValue &&
              errors.discountValue
            )}
            helperText={
              touched.discountValue &&
              errors.discountValue
            }
          />
        </Grid>
      </>
    )}
  </Grid>
)}
                  {!values.type && (
                    <Typography
                      color="textSecondary"
                    >
                      Please select a
                      Promotion Type in
                      Step 1.
                    </Typography>
                  )}
                </CardContent>
              </Card>
            )}
            {activeStep === 3 && (
              <Card
                className={classes.card}
              >
                <CardContent>
                  <Typography
                    variant="h5"
                    className={
                      classes.sectionTitle
                    }
                  >
                    Usage
                  </Typography>
                  <Grid
                    container
                    spacing={2}
                  >
                    {/* Total Uses */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Total Uses"
                        name="totalUses"
                        value={
                          values.totalUses
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(
                          touched.totalUses &&
                          errors.totalUses
                        )}
                        helperText={
                          touched.totalUses &&
                          errors.totalUses
                        }
                      />
                    </Grid>
                    {/* Uses Per User */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Uses Per User"
                        name="usesPerUser"
                        value={
                          values.usesPerUser
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(
                          touched.usesPerUser &&
                          errors.usesPerUser
                        )}
                        helperText={
                          touched.usesPerUser &&
                          errors.usesPerUser
                        }
                      />
                    </Grid>
                    {/* Uses Per Device */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Uses Per Device"
                        name="usesPerDevice"
                        value={
                          values.usesPerDevice
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(
                          touched.usesPerDevice &&
                          errors.usesPerDevice
                        )}
                        helperText={
                          touched.usesPerDevice &&
                          errors.usesPerDevice
                        }
                      />
                    </Grid>
                    {/* Uses Per Mobile */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Uses Per Mobile"
                        name="usesPerMobile"
                        value={
                          values.usesPerMobile
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(
                          touched.usesPerMobile &&
                          errors.usesPerMobile
                        )}
                        helperText={
                          touched.usesPerMobile &&
                          errors.usesPerMobile
                        }
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}
            {activeStep === 4 && (
              <Card
                className={classes.card}
              >
                <CardContent>
                  <Typography
                    variant="h5"
                    className={
                      classes.sectionTitle
                    }
                  >
                    Stacking
                  </Typography>
                  {/* Stacking */}
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                  >
                    Stacking
                  </Typography>
                  <RadioGroup
                    row
                    name="stacking"
                    value={
                      values.stacking
                    }
                    onChange={
                      handleChange
                    }
                  >
                    <FormControlLabel
                      value="EXCLUSIVE"
                      control={
                        <Radio />
                      }
                      label="Exclusive"
                    />
                    <FormControlLabel
                      value="STACKABLE"
                      control={
                        <Radio />
                      }
                      label="Stackable"
                    />
                  </RadioGroup>
                  {/* Free Shipping */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="allowFreeShipping"
                        checked={
                          values.allowFreeShipping
                        }
                        onChange={
                          handleChange
                        }
                      />
                    }
                    label="Allow with Free Shipping"
                  />
                  {/* Referral */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="allowReferral"
                        checked={
                          values.allowReferral
                        }
                        onChange={
                          handleChange
                        }
                      />
                    }
                    label="Allow with Referral"
                  />
                </CardContent>
              </Card>
            )}
            {errors.submit && (
              <Box mt={2}>
                <FormHelperText error>
                  {errors.submit}
                </FormHelperText>
              </Box>
            )}
            <Box
              className={
                classes.buttonContainer
              }
            >
              {/* Back */}
              <Button
                variant="outlined"
                disabled={
                  activeStep === 0 ||
                  isSubmitting
                }
                onClick={handleBack}
              >
                Back
              </Button>
              {/* Next */}
              {activeStep <
                steps.length - 1 && (
                <Button
                  variant="contained"
                  color="primary"
                  className={
                    classes.nextButton
                  }
                  onClick={() =>
                    handleNext(
                      values,
                      validateForm,
                      setTouched
                    )
                  }
                  disabled={
                    isSubmitting
                  }
                >
                  Next
                </Button>

              )}
              {/* Create */}
              {activeStep === steps.length - 1 && (
                <Button
                  variant="contained"
                  color="secondary"
                  className={
                    classes.nextButton
                  }
                  type="submit"
                  disabled={
                    isSubmitting
                  }
                >
                  {isSubmitting ? (
                    <CircularProgress
                      size={22}
                    />
                  ) : (
                    "Create Promotion"
                  )}
                </Button>
              )}
            </Box>
          </Box>
        </form>
      )}
    </Formik>
  );
}

export default PromotionCreateForm;